import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const SendMultiChannel = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      d="M18 12C18.5523 12 19 11.5523 19 11C19 10.4477 18.5523 10 18 10H17V12H18Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M18 15C20.2091 15 22 13.2091 22 11C22 8.79086 20.2091 7 18 7"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 6.99995L14.1464 3.8535C14.4614 3.53852 15 3.76161 15 4.20706V17.7928C15 18.2383 14.4614 18.4614 14.1464 18.1464L11 15H9L10.1675 18.5026C10.5771 19.7312 9.66261 21 8.36754 21C7.55086 21 6.8258 20.4774 6.56754 19.7026L5.33333 16H4C2.89543 16 2 15.1045 2 14V8.99995C2 7.89538 2.89543 6.99995 4 6.99995H11Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
